import { render, staticRenderFns } from "./OrdinativoAllegati.vue?vue&type=template&id=a0d3b820&"
import script from "./OrdinativoAllegati.vue?vue&type=script&lang=js&"
export * from "./OrdinativoAllegati.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
installComponents(component, {VBtn,VCard,VCardTitle,VDataTable,VFileInput})
